/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function setStyle(el, styles) {
  var keys = Object.keys(styles);
  keys.forEach(function (key) {
    el.style[key] = styles[key];
  });
}

exports["default"] = setStyle;
//# sourceMappingURL=set-style.js.map
